import { Component, input, OnInit, output, ChangeDetectionStrategy } from '@angular/core';
import type { CategoryTreeItemDto } from '@api/models';

import { RouterLinkWithLang } from '../../directives/router-link-with-lang/router-link-with-lang.directive';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'side-catalog-menu',
  templateUrl: './side-catalog-menu.component.html',
  styleUrls: ['./side-catalog-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, RouterLinkWithLang],
})
export class SideCatalogMenuComponent implements OnInit {

  readonly categories = input<CategoryTreeItemDto[]>(undefined);

  readonly openCatalogMenu = output();

  constructor() { }

  ngOnInit(): void { }

  public onCatalogItemMouseOver(): void {
    this.openCatalogMenu.emit();
  }
}
